import React from 'react';
import { isSafeUrl } from '@atlaskit/adf-schema';
import ToolTip from '@atlaskit/tooltip';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { LazySingleLineSmartLink } from '@atlassian/jira-issue-field-smart-link/src/ui/single-line-smart-link/async.tsx';
import type { ExtraFieldText } from '../../../../../../model/extra-fields/types.tsx';
import { Container } from '../styled.tsx';
import { isDefault, parseContent } from '../utils/index.tsx';

type Props = { field: ExtraFieldText };

export function TextField({ field }: Props) {
	const isLink =
		field.renderer === 'url' &&
		!!field.text.trim() &&
		isSafeUrl(field.text) &&
		expValEquals('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true);

	const content = parseContent(field.text);
	return (
		<ToolTip content={field.label}>
			<Container
				aria-label={field.label}
				aria-hidden={isDefault(content) ? 'true' : 'false'}
				isDefault={isDefault(content)}
				isLink={isLink}
			>
				{isLink ? <LazySingleLineSmartLink anchorTarget="_blank" url={content} /> : content}
			</Container>
		</ToolTip>
	);
}
